import React, { FC, useEffect } from 'react';
import useUserMeQuery from '../../reactQuery/hooks/useUserMeQuery';
import Loader from '../Simple/Loader/Loader';

type CalendarSlotSelectionProps = {
	onTimeSelection: () => void;
	onScheduled: () => void;
	currentOrderNumber: number;
};

const CalendarSlotSelection: FC<CalendarSlotSelectionProps> = ({
	onTimeSelection,
	onScheduled,
	currentOrderNumber,
}) => {
	const { data: currentUser } = useUserMeQuery();
	useEffect(() => {
		if (currentUser) {
			// Function to load the Calendly widget script
			const loadCalendlyWidget = () => {
				const script = document.createElement('script');
				script.src = 'https://assets.calendly.com/assets/external/widget.js';
				script.async = true;
				document.body.appendChild(script);
			};

			// Load the widget script when the component mounts
			loadCalendlyWidget();

			// Clean up the script when the component unmounts
			return () => {
				const scripts = document.querySelectorAll(
					'script[src="https://assets.calendly.com/assets/external/widget.js"]',
				);
				scripts.forEach((script) => script.remove());
			};
		}
	}, [currentUser]);

	function isCalendlyEvent(e: any) {
		return (
			e.origin === 'https://calendly.com' &&
			e.data.event &&
			e.data.event.indexOf('calendly.') === 0
		);
	}

	window.addEventListener('message', (e: any) => {
		if (isCalendlyEvent(e)) {
			/* Example to get the name of the event */
			console.log('Event name:', e.data.event);

			/* Example to get the payload of the event */
			console.log('Event details:', e.data.payload);

			if (e.data.event === 'calendly.date_and_time_selected') {
				onTimeSelection();
			}
			if (e.data.event === 'calendly.event_scheduled') {
				onScheduled();
			}
		}
	});

	return currentUser ? (
		<div
			className="calendly-inline-widget"
			data-url={`https://calendly.com/codeway-today/mock-interview?hide_landing_page_details=1&hide_event_type_details=1&primary_color=222222&email=${
				currentUser?.email
			}&name=${`${currentUser?.firstName} ${currentUser?.lastName}`}&utm_campaign=${currentOrderNumber}`}
			style={{ minWidth: '320px', height: '750px' }}
		/>
	) : (
		<Loader />
	);
};

export default CalendarSlotSelection;
